module.exports = __webpack_public_path__ + "img/video.1370c70f.png";